import { Box, Flex, HStack, Text } from '@chakra-ui/react'
import { useCallback } from 'react'
import { type usePlacesAutocompleteServiceResponse } from 'react-google-autocomplete/lib/usePlacesAutocompleteService'
import { MdLocationPin } from 'react-icons/md'

interface AddressPredictionProps {
  getPlaceDetails: (place: any) => void
  showPredictions: (value: boolean) => void
  place: usePlacesAutocompleteServiceResponse['placePredictions'][number]
}

const AddressPrediction = ({
  getPlaceDetails,
  showPredictions,
  place,
}: AddressPredictionProps) => {
  const handleClick = useCallback(() => {
    getPlaceDetails(place)
    showPredictions(false)
  }, [getPlaceDetails, place, showPredictions])

  return (
    <Box
      _hover={{ bgColor: 'gray.100' }}
      cursor="pointer"
      borderTop="1px solid"
      borderBottom="1px solid"
      borderColor="gray.200"
      py="2"
      px="4"
      onClick={handleClick}
    >
      <HStack>
        <Box as={MdLocationPin} fontSize="24px" color="gray.300" />
        <Flex direction="column">
          <Text fontSize="14px" fontWeight="700" textTransform="capitalize">
            {place?.structured_formatting?.main_text}
          </Text>
          <Text fontSize="14px" textTransform="capitalize">
            {place?.structured_formatting?.secondary_text}
          </Text>
        </Flex>
      </HStack>
    </Box>
  )
}

export default AddressPrediction
